enum FeedbackRating {
  Bad = '0',
  Mediocre = '1',
  Good = '2',
}

export default FeedbackRating;
